import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store/index.js";
import clientes from "@/views/Clientes.vue";
import conexiones from "@/views/seguridad/Conexiones.vue";
import regionales from "@/views/Regionales.vue";
import departamentos from "@/views/Departamentos.vue";
import correos from "@/views/Correos.vue";
import firebase from "firebase/app";
import axiosServices from "@/services/axiosServices.js";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "login",
    component: () => import("@/components/Login.vue"),
  },
  {
    path: "/RestorePassword/:Hash",
    name: "RestorePass",
    component: () => import("@/views/newPass.vue"),
  },
  {
    path: "/DashBoard",
    name: "DashBoard",
    component: () => import("@/views/DashBoard.vue"),
  },
  {
    path: '/FormDinamicoReporte/:id',
    name: 'FormDinamicoReporte',
    component: () => import ('@/components/FormDinamicos/FormDinamicoReporte.vue'), 
  },
  {
    path: "/FormDinamic/:id",
    name: "FormDinamic",
    component: () => import("@/components/FormDinamicos/FormDinamicCorreo.vue"),
  },
  {
    path: "/FormDinamicNew/:id",
    name: "FormDinamicNew",
    component: () => import("@/components/FormDinamicos/FormDinamic.vue"),
  },
  {
    path: "/InformeRiesgos",
    name: "InformeRiesgos",
    component: () => import("@/components/Reportes/InformeRiesgos.vue"),
  },
  {
    path: "/GridDinamicos/:sIDForm",
    name: "GridDinamicos",
    component: () => import("@/components/Grid/GridDinamico.vue"),
  },
  {
    path: "/GridDinamicosNew/:sIDForm",
    name: "GridDinamicosNew",
    component: () => import("@/components/Grid/GridDinamicoNew.vue"),
  },
  {
    path: "/buildDinamicos",
    name: "buildDinamicos",
    component: () => import("@/views/buildDinamicos.vue"),
  },
  {
    path: "/FormDinamicPQR/:id",
    name: "FormDinamicPQR",
    component: () => import("@/views/FormDinamicPQR.vue"),
  },
  {
    path: "/ViewRspPQR/:id",
    name: "ViewRspPQR",
    component: () => import("@/views/RspFormDinamicPQR.vue"),
  },
  {
    path: "/ExportPQR",
    name: "ExportPQR",
    component: () => import("@/views/ExportPQRFormDinamic.vue"),
  },
  {
    path: "/buildCorreos/:idCorreos",
    name: "buildCorreos",
    component: () => import("@/views/buildCorreos.vue"),
  },
  {
    path: '/MostrarImangen/:sFilename',
    name: 'MostrarImagen',
    component: () => import('@/views/seif/Utils/MostrarImagen.vue'),
  },
  {
    path: '/MostrarInforme/:sCasoCorreo/:nIdCaso',
    name: 'MostrarInforme',
    component: () => import('@/views/seif/Utils/MostrarInforme.vue'),
  },
  {
    path: "/Inicio/:Modulo",
    name: "Inicio",
    component: () => import("@/views/Contenedor.vue"),
    props: true,
    children: [
      /**
       * Modulo de ayuda
       */
      {
        path: "/Inicio/:Modulo/dashboard",
        name: "DashboardAyuda",
        components: {
          config: () => import("@/views/ayuda/dashboard.vue")
        }
      },
      {
        path: "/Inicio/:Modulo/dashboard/productos",
        name: "ProductosAyuda",
        components: {
          config: () => import("@/views/ayuda/productosAll.vue")
        }
      },
      {
        path: "/Inicio/:Modulo/dashboard/producto/:idProducto",
        name: "ProductoAyuda",
        components: {
          config: () => import("@/views/ayuda/producto.vue")
        }
      },
      {
        path: "/Inicio/:Modulo/dashboard/producto/:idProducto/modulo/:idModulo",
        name: "ModuloAyuda",
        components: {
          config: () => import("@/views/ayuda/modulo.vue")
        }
      },
      {
        path:
          "/Inicio/:Modulo/dashboard/producto/:idProducto/modulo/:idModulo/pregunta/:idPregunta",
        name: "PreguntaAyuda",
        components: {
          config: () => import("@/views/ayuda/pregunta.vue")
        }
      },
      {
        path: "/Inicio/:Modulo/pregunta/nueva",
        name: "NuevaPregunta",
        components: {
          config: () => import("@/views/ayuda/pregunta-nueva.vue")
        }
      },
      {
        path: "/Inicio/:Modulo/pregunta/busqueda",
        name: "BusquedaPregunta",
        components: {
          config: () => import("@/views/ayuda/busqueda.vue")
        }
      },
      /* MODULO OPERACIONES */
      {
        path: "/Inicio/:Modulo/acta-reunion/pqr",
        name: "ActaReunionPQR",
        components: {
          config: () => import("@/views/operaciones/ActaReunionPqr.vue"),
        },
      },
      //modulo para la integracion de ODDO
      {
        path: "/Inicio/:Modulo/integracion-ODDO",
        name: "IntegracionODDO",
        components: {
          config: () => import("@/views/operaciones/IntegracionODDO.vue"),
        },
      },
      {
        path: "/Inicio/:Modulo/supervision",
        name: "Supervision",
        components: {
          config: () => import("@/views/operaciones/Supervision.vue"),
        },
      },
      {
        path: "/Inicio/:Modulo/cop-preguntas",
        name: "CopPreguntas",
        components: {
          config: () => import("@/views/operaciones/CopPreguntas.vue"),
        },
      },
      {
        path: "/Inicio/:Modulo/cop-tipos-gestion",
        name: "CopTiposGestion",
        components: {
          config: () => import("@/views/operaciones/CopTiposGestion.vue"),
        },
      },
      {
        path: "/Inicio/:Modulo/cop-tipos-visita",
        name: "CopTiposVisita",
        components: {
          config: () => import("@/views/operaciones/CopTiposVisita.vue"),
        },
      },
      {
        path: "/Inicio/:Modulo/cop-partes-moto",
        name: "CopPartesMoto",
        components: {
          config: () => import("@/views/operaciones/CopPartesMoto.vue"),
        },
      },
      {
        path: "/Inicio/:Modulo/cop-vehiculos",
        name: "CopVehiculos",
        components: {
          config: () => import("@/views/operaciones/CopVehiculos.vue"),
        },
      },
      {
        path: "/Inicio/:Modulo/cop-tipos-evento",
        name: "CopTiposEvento",
        components: {
          config: () => import("@/views/operaciones/CopTiposEvento.vue"),
        },
      },
      {
        path: "/Inicio/:Modulo/cop-tipos-tiempo",
        name: "CopTiposTiempo",
        components: {
          config: () => import("@/views/operaciones/CopTiposTiempo.vue"),
        },
      },
      {
        path: "/Inicio/:Modulo/cop-tipos-novedades-operativas",
        name: "CopTiposNovedadesOperativas",
        components: {
          config: () =>
            import("@/views/operaciones/CopTiposNovedadesOperativas.vue"),
        },
      },
      {
        path: "/Inicio/:Modulo/compromisos-reunion",
        name: "CompromisosReunion",
        components: {
          config: () => import("@/views/operaciones/CompromisosReunion.vue"),
        },
      },
      {
        path: "/Inicio/:Modulo/compromisos-historico",
        name: "CompromisosHistorico",
        components: {
          config: () => import("@/views/operaciones/CompromisosHistorico.vue"),
        },
      },
      {
        path: "/Inicio/:Modulo/acta-seguimiento",
        name: "ActaSeguimiento",
        components: {
          config: () => import("@/views/operaciones/ActaSeguimiento.vue"),
        },
      },
      {
        path: "/Inicio/:Modulo/acta-reunion-lista-dinamica",
        name: "ActaReunionListaDinamica",
        components: {
          config: () =>
            import("@/views/operaciones/ActaReunionListaDinamica.vue"),
        },
      },
      {
        path: "/Inicio/:Modulo/acta-reunion-cc",
        name: "ActaReunionCC",
        components: {
          config: () => import("@/views/operaciones/ActaReunionCC.vue"),
        },
      },
      {
        path: "/Inicio/:Modulo/acta-administrativo",
        name: "ActaAdministrativo",
        components: {
          config: () => import("@/views/operaciones/ActaAdministrativo.vue"),
        },
      },
      {
        path: "/Inicio/:Modulo/rondas-monitoreo",
        name: "RondasMonitoreo",
        components: {
          config: () => import("@/views/operaciones/RondasMonitoreo.vue"),
        },
      },
      {
        path: "/Inicio/:Modulo/inspeccion-preoperacional",
        name: "InspeccionPreoperacional",
        components: {
          config: () =>
            import("@/views/operaciones/InspeccionPreoperacional.vue"),
        },
      },
      {
        path: "/Inicio/:Modulo/novedades-operativas",
        name: "NovedadesOperativas",
        components: {
          config: () => import("@/views/operaciones/NovedadesOperativas.vue"),
        },
      },
      {
        path: "/Inicio/:Modulo/compromisos-gestion",
        name: "CompromisosGestion",
        components: {
          config: () => import("@/views/operaciones/CompromisosGestion.vue"),
        },
      },

      /***********************************************
       * Modulo de SAC
       ***********************************************/
      {
        path: "/Inicio/:Modulo/reporte-mis-tickets",
        name: "MisReportes",
        components: {
          config: () => import("@/views/sac/Reportes.vue"),
        },
      },
      {
        path: "/Inicio/:Modulo/crearTicket",
        name: "MisReportes",
        components: {
          config: () => import("@/views/sac/CrearTicket.vue"),
        },
      },
      /***********************************************
       * Modulo de SAC
       ***********************************************/
      {
        path: "/Inicio/:Modulo/casoscorreos",
        name: "CasosCorreos",
        components: {
          config: () => import("@/views/Configuracion/CasosCorreos.vue"),
        },
      },
      {
        path: "/Inicio/:Modulo/clientes",
        name: "clientes",
        components: {
          config: clientes,
        },
      },
      {
        path: "/Inicio/:Modulo/conexiones",
        name: "conexiones",
        components: {
          config: conexiones,
        },
      },
      {
        path: "/Inicio/:Modulo/linkCrontabs",
        name: "ConfiguracionCrontabs",
        components: {
          config: () => import("@/views/Configuracion/ConfiguracionCrontabs.vue"),
        },
      },
      {
        path: "/Inicio/:Modulo/regionales",
        name: "regionales",
        components: {
          config: regionales,
        },
      },
      {
        path: "/Inicio/:Modulo/departamentos",
        name: "departamentos",
        components: {
          config: departamentos,
        },
      },
      {
        path: "/Inicio/:Modulo/correos",
        name: "correos",
        components: {
          config: correos,
        },
      },
      // Modulo de pqr
      //Modulo de PQR
      {
        path: "/Inicio/:Modulo/Configuracion/Perfil",
        name: "Perfil",
        components: {
          config: () => import("@/views/Pqr/Configuracion/Perfil.vue"),
        },
      },
      {
        path: "/Inicio/:Modulo/Configuracion/TiemposGestion",
        name: "TiemposGestion",
        components: {
          config: () =>
            import("@/views/Pqr/Configuracion/TiemposGestion.vue"),
        },
      },
      {
        path: "/Inicio/:Modulo/Configuracion/ParametrizacionDias",
        name: "ParametrizacionDias",
        components: {
          config: () =>
            import("@/views/Pqr/Configuracion/ParametrizacionDias.vue"),
        },
      },
      {
        path: "/Inicio/:Modulo/Configuracion/ClasificacionPqr",
        name: "ClasificacionPqr",
        components: {
          config: () =>
            import("@/views/Pqr/Configuracion/ClasificacionPqr.vue"),
        },
      },
      {
        path: "/Inicio/:Modulo/Configuracion/PermisosCierrePqr",
        name: "PermisosCierrePqr",
        components: {
          config: () =>
            import("@/views/Pqr/Configuracion/PermisosCierrePqr.vue"),
        },
      },
      // carousel
      {
        path: "/Inicio/:Modulo/Configuracion/carousel",
        name: "Carousel",
        components: {
          config: () =>
            import("@/views/Pqr/Configuracion/Carousel.vue"),
        },
      },
      //Banner
      {
        path: "/Inicio/:Modulo/Configuracion/banner",
        name: "banner",
        components: {
          config: () =>
            import("@/views/Pqr/Configuracion/Banner.vue"),
        },
      },
      {
        path: "/Inicio/:Modulo/GestionPqr",
        name: "GestionPqr",
        components: {
          config: () => import("@/views/Pqr/GestionPqr.vue"),
        },
      },
      {
        path: "/Inicio/:Modulo/GestionPqrCliente",
        name: "GestionPqr",
        components: {
          config: () => import("@/views/Pqr/GestionPqrClientes.vue"),
        },
      },
      {
        path: "/Inicio/:Modulo/nuevo",
        name: "FormNuevoPqr",
        components: {
          config: () => import("@/views/Pqr/FormNuevoPqr.vue"),
        },
      },
      {
        path: "/Inicio/:Modulo/Reportes/MisClientes",
        name: "MisClientes",
        components: {
          config: () => import("@/views/Pqr/Reportes/MisClientes.vue"),
        },
      },
      {
        path: "/Inicio/:Modulo/Reportes/MisRequerimientos",
        name: "MisRequerimientos",
        components: {
          config: () =>
            import("@/views/Pqr/Reportes/MisRequerimientos.vue"),
        },
      },
      {
        path: "/Inicio/:Modulo/Reportes/PQRGeneral",
        name: "PQRGeneral",
        components: {
          config: () => import("@/views/Pqr/Reportes/PQRGeneral.vue"),
        },
      },
      {
        path: "/Inicio/:Modulo/Reportes/TiemposPorDepartamento",
        name: "TiemposPorDepartamento",
        components: {
          config: () =>
            import("@/views/Pqr/Reportes/TiemposPorDepartamento.vue"),
        },
      },

      //Modulo de licencias
      {
        path: "/Inicio/:Modulo/AdministracionLicencias",
        name: "AdministracionLicencias",
        components: {
          config: () => import("@/views/Licencias/AdministracionLicencias.vue"),
        },
      },
      {
        path: "/Inicio/:Modulo/LicenciasCliente/:id",
        name: "LicenciasCliente",
        components: {
          config: () => import("@/views/Licencias/LicenciasCliente.vue"),
        },
      },
      {
        path: "/Inicio/:Modulo/EditarLicenciasCliente/:id",
        name: "EditarLicenciasCliente",
        components: {
          config: () => import("@/views/Licencias/EditarLicenciasCliente.vue"),
        },
      },
      {
        path: "/Inicio/:Modulo/HistoricoLicencias",
        name: "HistoricoLicencias",
        components: {
          config: () => import("@/views/Licencias/HistoricoLicencias.vue"),
        },
      },
      {
        path: '/Inicio/:Modulo/Dash',
        name: "indicadores",
        components: {
          config: () => import("@/views/Indicadores/Indicadores.vue"),
        },
      },
      
    ],
  },
];
// const urlParams = window.location.search.split('?')[1];
// store.dispatch('saveParamsProyect', urlParams)
const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

// interceptor para validar que se este logueado
router.beforeEach(async (to, from, next) => {
  const urlParams = window.location.search.split('?')[1]
  let sSubdomain = ''
  if (typeof window.location.host.split('.')[0] !== 'undefined') {
    if (window.location.host.split('.')[0].includes('localhost')) {
      sSubdomain = 'desarrollo';
    } else {
      sSubdomain = window.location.host.split('.')[0]
    }
  } else {
    sSubdomain = 'desarrollo';
  }

  if(to.query.t != undefined && to.query.ip != undefined){
    // Como estamos entrando de manera externa, limpiamos el token por si existia un sesion previa y evitar conflictos de autenticacion
    store.dispatch('saveToken', "")    
    let sToken = to.query.t
    let sIP = to.query.ip
    store.dispatch('save_sIP', sIP);
    await store.dispatch('saveToken', sToken);
  }

  await store.dispatch('saveSubDomain', sSubdomain);
  await store.dispatch('saveParamsProyect', urlParams)

  let oLog = {
    page_location: window.location.origin + "/" + to.fullPath,
    page_path: to.fullPath,
    page_title: to.name,
  };
  firebase.analytics().logEvent("page_view", oLog);

  let bLimpiarFiltroGlobal = true
  if(to.name === 'GridDinamicos' && from.name ===  "FormDinamicoReporte"){
    bLimpiarFiltroGlobal = false
  }  
  if (from.name === 'GridDinamicos' && to.name ===  "FormDinamicoReporte"){
    bLimpiarFiltroGlobal = false
  }  
  if(bLimpiarFiltroGlobal) store.dispatch('filterSeccion/ClearAll')


  // inscrustado lateral
  // if(to.query.incrustado) store.dispatch('savebIncrustado', to.query.incrustado);
  // else store.dispatch('savebIncrustado', false);

  // // inscrustado superior
  // if(to.query.incrustadoSuperior) store.dispatch('savebIncrustadoSuperior', to.query.incrustadoSuperior);
  // else store.dispatch('savebIncrustadoSuperior', false);

  let bIncrustado = (to.query.incrustado != undefined) ? (to.query.incrustado) : false
  if(eval(store.state.bIncrustado) && !to.query.incrustado) bIncrustado = true
  
  let bIncrustadoSuperior = (to.query.incrustadoSuperior != undefined) ? to.query.incrustadoSuperior : false
  store.dispatch('savebIncrustado', eval(bIncrustado));
  store.dispatch('savebIncrustadoSuperior', bIncrustadoSuperior);


  //Primero validamos si se intenta acceder al modulo de ayuda de manera externa
  let bIsCentroAyuda=false
  if(to.fullPath.includes("/Inicio/centro-de-ayuda/dashboard/producto/") && (store.state.token == "")){
    bIsCentroAyuda=true
    store.dispatch('savebIncrustado', true);
    store.dispatch('savebIncrustadoSuperior', true);
    localStorage.bIncrustado=true;
    localStorage.bIncrustadoSuperior="true";
  }

  /**
   * Se realiza proceso de loggeo para el modulo de sac
   */
  const nIdCliente  = (to.query.nIdCliente != undefined) ? to.query.nIdCliente : '',
        nIdPerfil   = (to.query.nIdPerfil != undefined) ? to.query.nIdPerfil : '',
        // nIdUsuario  = (to.query.nIdUsuario != undefined) ? to.query.nIdUsuario : '',
        sUsuario    = (to.query.sUsuario != undefined) ? to.query.sUsuario : '';
  if(nIdCliente && nIdPerfil && sUsuario) {
    // Como estamos entrando de manera externa, limpiamos el token por si existia un sesion previa y evitar conflictos de autenticacion
    store.dispatch('saveToken', "")
    try {
      const { nStatusCode, aData } = await axiosServices.getConfiguration("/login/token", false, "usuario=Externo&id=0&password=827ccb0eea8a706c4c34a16891f84e7b")
      if(nStatusCode === 200) {
        store.dispatch('saveToken', aData)
        // seteamos los valores que vienen por url
        store.dispatch('savesNombreUsuario', sUsuario)
        store.dispatch('saveIdUser', 0)
        store.dispatch('saveIdPerfil', nIdPerfil)
        store.dispatch('saveIdCliente', nIdCliente)
        store.dispatch('setLogin', true)
        // asignamos el modulo de id de pqr y el nombre del modulo
        const PQR_TITULO = "Servicio al Cliente (SAC)";
        store.dispatch('saveIdModule', 17);
        store.dispatch('saveTitleModule', PQR_TITULO);

        // try {
        //   const axiosUsuario = await axiosServices.getConfiguration(`/login/usuario/${nIdUsuario}`, true, '');
        //   if(axiosUsuario.nStatusCode === 200) {
        //     const oData = axiosUsuario.aData;
        //     store.dispatch('saveIdDeparment', oData.Departamento_idDepartamento);
        //     store.dispatch('saveDependencias', oData.idDependencia);
        //     store.dispatch('saveIdPqrPerfil', oData.idPQR_perfil);
        //   }
        // } catch (error) {
        //   error;
        // }
        const equivalencias = await axiosServices.getConfiguration("/login/equivalencias", true, '')
        store.dispatch('saveDiccionario', equivalencias.aData);
      }
    } catch (error) {
      // code
    }
    // xD
  }
  switch (to.name) {
    case "login":
    case "RestorePass":
    case "FormDinamic":
    case "GridDinamicos":
    case "buildDinamicos":
    case "FormDinamicoReporte":
    case "GridDinamicosNew":
    case "FormDinamicNew":
    case "FormDinamicPQR":
    case "ViewRspPQR":
    case "ExportPQR":
    case "DashboardAyuda":
    case "NuevaPregunta":
    case "ProductoAyuda":
    case "ModuloAyuda":
    case "PreguntaAyuda":
    case "BusquedaPregunta":
    case "ProductosAyuda":
    case "MostrarInforme":
    case "MostrarImagen":
    case "InformeRiesgos": {
      next();
      break;
    }
    default: {
      if (!store.state.login && !bIsCentroAyuda) {
        next("/");
      } else {
        next();
      }
      break;
    }
  }
});

export default router;
